export { IndexPage } from './index-page';
